// src/components/EnrollFormModal.js
import React from "react";
import "../styles/EnrollFormModal.css";

const EnrollFormModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="enroll-modal-overlay">
      <div className="enroll-modal">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-heading">Enroll Now</h2>

        <form className="enroll-form">
          <label>
            Full Name:
            <input type="text" required />
          </label>
          <label>
            Email Address:
            <input type="email" required />
          </label>
          <label>
            Phone Number:
            <input type="tel" required />
          </label>
          <label>
            Course Interested In:
            <select required>
              <option value="">Select a course</option>
              <option>Data Science</option>
              <option>Data Analytics</option>
              {/* <option></option>
              <option>Data Science</option> */}
              <option>Generative AI</option>
              <option>MLOps</option>
              <option>Data Engineering</option>
            </select>
          </label>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default EnrollFormModal;
